import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import IconMenuButton from 'components/layout/IconMenuButton'
import MenuButton from 'components/layout/MenuButton'
import icons from 'settings/icons'

const MoreIcon = icons.more
const PDFIcon = icons.pdf

const useStyles = makeStyles(theme => ({
  button: {
    whiteSpace: 'nowrap',
    textTransform: 'none',
    color: theme.palette.grey[700],
  },
}))

const TakeOffOptionsButton = ({
  onExportPDF,
}) => {

  const classes = useStyles()

  const options = [{
    title: 'Export PDF',
    icon: PDFIcon,
    handler: onExportPDF,
  }]

  if(options.length <= 0) return null

  return (
    <MenuButton 
      title="Options"
      icon={ MoreIcon }
      items={ options }
      buttonProps={{
        variant: 'outlined',
        className: classes.button,
        size: 'small',
      }}
    />
  )
}

export default TakeOffOptionsButton